import { createSlice } from '@reduxjs/toolkit';
import { PayloadAction } from '@reduxjs/toolkit/dist/createAction';
import { initialRegistrationState, RegistrationState } from './registration.interface';
import { Patient } from '../../model/Patient';
import { Doctor } from '../../model/Doctor';
import { FormInfo } from '../../model/FormInfo';
import { Clinic } from '../../model/Clinic';
import { UploadedFile } from '../../model/UploadedFile';
import { Urgency } from '../../model/enums/Urgency';

const registrationSlice = createSlice({
  name: 'registration',
  initialState: initialRegistrationState,
  reducers: {
    resetRegistration: () => {
      return initialRegistrationState;
    },
    setFormInfo: (state: RegistrationState, action: PayloadAction<FormInfo>) => {
      state.formInfo = action.payload;
    },
    setGoal: (state: RegistrationState, action: PayloadAction<string>) => {
      state.goal = action.payload;
    },
    setClinic: (state: RegistrationState, action: PayloadAction<Clinic>) => {
      state.clinic = action.payload;
      state.goal = ''; // clear selected goal when clinic is changed
      state.diagnoses = []; // clear selected diagnoses when clinic is changed
    },
    setUrgency: (state: RegistrationState, action: PayloadAction<Urgency>) => {
      state.urgency = action.payload;
    },
    setDiagnoses: (state: RegistrationState, action: PayloadAction<string[]>) => {
      state.diagnoses = [
        ...action.payload
      ];
    },
    setCustomDiagnosis: (state: RegistrationState, action: PayloadAction<string>) => {
      state.customDiagnosis = action.payload;
    },
    setDescription: (state: RegistrationState, action: PayloadAction<string>) => {
      state.description = action.payload;
    },
    setDoctor: (state: RegistrationState, action: PayloadAction<Partial<Doctor>>) => {
      state.doctor = {
        ...state.doctor,
        ...action.payload
      };
    },
    setPatient: (state: RegistrationState, action: PayloadAction<Partial<Patient>>) => {
      state.patient = {
        ...state.patient,
        ...action.payload
      };
    },
    setUploads: (state: RegistrationState, action: PayloadAction<UploadedFile[]>) => {
      state.uploads = action.payload;
    }
  }
});

export const registrationReducer = registrationSlice.reducer;
export const registrationActions = registrationSlice.actions;
